import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import V3Header from '../components/V3Header';
import V3Footer from '../components/V3Footer';
import PdfScrollSection from '../components/PdfScrollSection';
import {
  CasteEquationVisual,
  PartyDominanceVisual,
  MoneyGameVisual,
  YouthTalentVisual,
} from '../components/visuals/SponsorVisuals';
import { useLanguage } from '../LanguageContext';
import { submitToSheet } from '../formSubmit';
import '../V3.css';

const V3SponsorProgram = () => {
  const { t } = useLanguage();
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    submitToSheet('prayojak', e.currentTarget);
    setSubmitted(true);
  };

  const journeySteps = t('sponsor.journeySteps');
  const benefits = t('sponsor.benefits');
  const dashboardFeatures = t('sponsor.dashboardFeatures');
  const tableRows = t('sponsor.tableRows');

  return (
    <div className="v3-app">
      <div className="v3-page">
        <V3Header
          primaryCta={(
            <>
              <Link to="/apply" className="v3-btn">{t('common.becomeCandidate')}</Link>
              <a href="#sponsor-form" className="v3-btn primary">{t('common.becomeSponsorArrow')}</a>
            </>
          )}
        />
        <div className="v3-hero">
          <div className="v3-tag-eyebrow">{t('sponsor.eyebrow')}</div>
          <h1>{t('sponsor.title')}</h1>
          <p>{t('sponsor.intro')}</p>
        </div>

        <PdfScrollSection
          title="Sponsor Pitch"
          src={`${process.env.PUBLIC_URL}/docs/sponsor-pitch.pdf`}
          height={780}
        />

        <PdfScrollSection
          title="Vote Nirdharit Kaise Karein"
          src={`${process.env.PUBLIC_URL}/docs/sponsor-value-pitch.pdf`}
          height={780}
        />

        <section className="v3-block">
          <h2>{t('sponsor.lastTimeTitle')}</h2>
          <p>{t('sponsor.lastTimeDesc')}</p>
          <div className="v3-grid3">
            <CasteEquationVisual caption={t('sponsor.casteCalc')} />
            <PartyDominanceVisual caption={t('sponsor.partyDominance')} />
            <MoneyGameVisual caption={t('sponsor.moneyGame')} />
          </div>
          <div className="v3-dark-banner">{t('sponsor.darkBanner')}</div>
          <p style={{ fontSize: 13, marginTop: 10, fontStyle: 'italic' }}>{t('sponsor.darkBannerSub')}</p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.hiddenStrengthTitle')}</h2>
          <div className="v3-grid2">
            <YouthTalentVisual caption={t('sponsor.youthIcon')} />
            <div>
              <p>{t('sponsor.youthDesc1')}</p>
              <p><strong>{t('sponsor.youthDesc2')}</strong></p>
            </div>
          </div>
        </section>

        <section className="v3-block gray">
          <p style={{ textAlign: 'center', fontSize: 18, margin: '0 0 12px' }}><strong>{t('sponsor.meritLine')}</strong></p>
          <p style={{ textAlign: 'center', fontSize: 15 }}>{t('sponsor.meritFormula')}</p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.journeyTitle')}</h2>
          <div className="v3-sub">{t('sponsor.journeySub')}</div>
          <div className="v3-grid4">
            {Array.isArray(journeySteps) && journeySteps.map(({ title, desc }, i) => (
              <div key={title} className="v3-step">
                <div className="v3-num">{i + 1}</div>
                <strong style={{ fontSize: 13 }}>{title}</strong>
                {desc && <p style={{ fontSize: 12, margin: '6px 0 0', color: '#555' }}>{desc}</p>}
              </div>
            ))}
          </div>
          <p style={{ fontSize: 14, marginTop: 16 }}><strong>{t('sponsor.journeyClose')}</strong></p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.meritTestTitle')}</h2>
          <div className="v3-grid2">
            <div className="v3-wire-block">
              <h3 style={{ marginTop: 0 }}>{t('leadership.writtenExam')}</h3>
              <ul className="v3-wire-list">
                {t('sponsor.meritWrittenItems').map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
            <div className="v3-wire-block">
              <h3 style={{ marginTop: 0 }}>{t('leadership.interview')}</h3>
              <ul className="v3-wire-list">
                {t('leadership.interviewItems').map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          </div>
          <p style={{ fontSize: 15, marginTop: 14 }}>
            <strong>{t('sponsor.panelNote')}</strong> {t('sponsor.panelDesc')}
          </p>
        </section>

        <section className="v3-block light-gray">
          <h2>{t('sponsor.publicForumTitle')}</h2>
          <p>{t('sponsor.publicForumDesc')}</p>
          <p><strong>{t('sponsor.publicForumClose')}</strong></p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.realGameTitle')}</h2>
          <ul className="v3-wire-list">
            {t('sponsor.realGameItems').map((item) => <li key={item}>{item}</li>)}
          </ul>
          <p style={{ marginTop: 12 }}><strong>{t('sponsor.realGameClose')}</strong></p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.scaleTitle')}</h2>
          <div className="v3-sub">{t('sponsor.scaleSub')}</div>
          <table className="v3-wire-table">
            <thead>
              <tr>
                <th>{t('sponsor.tableProgram')}</th>
                <th>{t('sponsor.tablePanchayats')}</th>
                <th>{t('sponsor.tableInvestment')}</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(tableRows) && tableRows.map((row) => (
                <tr key={row.program}>
                  <td>{row.program}</td>
                  <td>{row.panchayats}</td>
                  <td>{row.investment}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p style={{ fontSize: 12, color: '#777', marginTop: 8 }}>{t('sponsor.perPanchayat')}</p>
          <p style={{ fontSize: 14, marginTop: 8 }}>{t('sponsor.sarpanchNetwork')}</p>
        </section>

        <section className="v3-block gray">
          <h2>{t('sponsor.accountabilityEngineTitle')}</h2>
          <ul className="v3-wire-list">
            {t('sponsor.accountabilityEngineSteps').map((item) => <li key={item}>{item}</li>)}
          </ul>
          <p style={{ marginTop: 12 }}>{t('sponsor.accountabilityEngineClose')}</p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.nameWithWinsTitle')}</h2>
          <ul className="v3-wire-list">
            {t('sponsor.nameWithWinsItems').map((item) => <li key={item}>{item}</li>)}
          </ul>
          <p style={{ marginTop: 12 }}><strong>{t('sponsor.nameWithWinsClose')}</strong></p>
        </section>

        <section className="v3-block">
          <h2>{t('sponsor.benefitsTitle')}</h2>
          <div className="v3-grid3">
            {Array.isArray(benefits) && benefits.map((b, i) => (
              <div key={b.title} className="v3-wire-block">
                <span className="v3-label">{t('common.benefit')} {String(i + 1).padStart(2, '0')}</span>
                <strong>{b.title}</strong>
                <p style={{ fontSize: 13 }}>{b.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="v3-block gray">
          <h2>{t('sponsor.dashboardTitle')}</h2>
          <div className="v3-sub">{t('sponsor.dashboardSub')}</div>
          <div className="v3-grid4">
            {Array.isArray(dashboardFeatures) && dashboardFeatures.map(({ title, items }) => (
              <div key={title} className="v3-wire-block">
                <strong style={{ fontSize: 13, display: 'block', textAlign: 'center' }}>{title}</strong>
                <ul className="v3-wire-list" style={{ fontSize: 12, marginTop: 8 }}>
                  {items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </div>
            ))}
          </div>
          <p style={{ fontSize: 13, marginTop: 14 }}>{t('sponsor.dashboardDesc')}</p>
          <p style={{ fontSize: 12, color: '#777', marginTop: 8 }}>{t('sponsor.dashboardNote')}</p>
        </section>

        <div className="v3-cta-strip">{t('sponsor.cta')}</div>

        <section className="v3-block light-gray" id="sponsor-form">
          <h2>{t('sponsor.formTitle')}</h2>
          {submitted ? (
            <p style={{ fontSize: 15, color: '#333' }}>{t('sponsor.formSuccess')}</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <h3 style={{ fontSize: 15, marginBottom: 12 }}>{t('sponsor.formBasicInfo')}</h3>
              <div className="v3-grid2">
                <div>
                  <div className="v3-form-field">
                    <label htmlFor="fullName">{t('sponsor.formFullName')}</label>
                    <input id="fullName" name="fullName" required />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="party">{t('sponsor.formParty')}</label>
                    <input id="party" name="party" />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="role">{t('sponsor.formRole')}</label>
                    <input id="role" name="role" />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="state">{t('sponsor.formState')}</label>
                    <input id="state" name="state" />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="district">{t('sponsor.formDistrict')}</label>
                    <input id="district" name="district" />
                  </div>
                </div>
                <div>
                  <div className="v3-form-field">
                    <label htmlFor="email">{t('sponsor.formEmail')}</label>
                    <input id="email" name="email" type="email" required />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="phone">{t('sponsor.formPhone')}</label>
                    <input id="phone" name="phone" type="tel" required />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="program">{t('sponsor.formProgram')}</label>
                    <select id="program" name="program">
                      <option value="">{t('common.choose')}</option>
                      <option value="starter">{t('sponsor.formProgramStarter')}</option>
                      <option value="expansion">{t('sponsor.formProgramExpansion')}</option>
                      <option value="full">{t('sponsor.formProgramFull')}</option>
                    </select>
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="area">{t('sponsor.formArea')}</label>
                    <input id="area" name="area" />
                  </div>
                  <div className="v3-form-field">
                    <label htmlFor="message">{t('sponsor.formMessage')}</label>
                    <textarea id="message" name="message" />
                  </div>
                </div>
              </div>
              <button type="submit" className="v3-btn primary" style={{ width: 220 }}>
                {t('sponsor.formSubmit')}
              </button>
            </form>
          )}
          <p style={{ fontSize: 12, color: '#777', marginTop: 10 }}>{t('sponsor.formFooter')}</p>
        </section>
        <V3Footer />
      </div>
    </div>
  );
};

export default V3SponsorProgram;
